<template>
    <div class="inline-auto-width input-group-append">
        <slot></slot>
    </div>
</template>

<script>

export default {
    props: {
    },
    methods: {
    }
}
</script>

<style>
</style>
